import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DataService } from '../services/context/data.service';
import { RefDataService } from '../services/context/ref-data.service';
import * as fromModel from '../services/models/';

@Component({
  selector: 'gp-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'] 
})
export class SettingsComponent implements OnInit {

  @Output() hideSettings: EventEmitter<any> = new EventEmitter();
  isSettingsAvailable = true;
  errorMsg: string;
  settings: fromModel.CodeValue[];
  settingsToSave: fromModel.CodeValue[] = []; 
  planResultViewBy: fromModel.PLANRESULTVIEWBY = fromModel.PLANRESULTVIEWBY.PV;
  isDataChanged = false;

  form: FormGroup;

  constructor(private dataService: DataService,
    private refDataService: RefDataService,
    private readonly fb: FormBuilder,
    private currencyPipe: CurrencyPipe) { 
    this.form = this.fb.group({
        infRate: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        discountRate: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        preIncTaxRate:  ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        postIncTaxRate:  ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        preCGTaxRate:  ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        postCGTaxRate:  ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        expSpendingPattern: ['', [Validators.required]]
      }    
    );
  }

  ngOnInit(): void {
    this.showHideSettings();
    this.setFormValues();  
  }

  getFormValue(settingKey: fromModel.SETTINGSCODE, singleKeyRef: fromModel.KEYREF){
    let value;
    if(singleKeyRef){
      value = this.refDataService.getKeyValueByCode(singleKeyRef);
    } 
    if(this.settings && this.settings.length>0){
      let _set = this.settings.find(set=> set.code === settingKey);
      if(_set){        
        value = _set.value;
      }      
    }
    return value;
  }

  setFormValues(){
    let infRate;
    let discountRate;
    let preIncTaxRate;
    let postIncTaxRate;
    let preCGTaxRate;
    let postCGTaxRate;
    let expSpendingPattern;


    this.settings = this.dataService.getAllSettings();

    // if(this.settings){
    //   let _set = this.settings.find(set=> set.code === fromModel.SETTINGSCODE.INF_RT);
    //   if(_set){        
    //     infRate = this.refDataService.getKeyValueByCode(_set.value);
    //   } else {
    //     infRate = this.refDataService.getKeyValueByCode(fromModel.KEYREF.InflRt);
    //   }
    // }

    infRate = this.getFormValue(fromModel.SETTINGSCODE.INF_RT, fromModel.KEYREF.InflRt);
    discountRate = this.getFormValue(fromModel.SETTINGSCODE.DISCOUNT_RT, fromModel.KEYREF.DiscountRt);
    preIncTaxRate = this.getFormValue(fromModel.SETTINGSCODE.PRE_INC_TX_RT, fromModel.KEYREF.PreRetIncomeTxRt);
    postIncTaxRate = this.getFormValue(fromModel.SETTINGSCODE.POST_INC_TX_RT, fromModel.KEYREF.PostRetIncomeTxRt);
    preCGTaxRate = this.getFormValue(fromModel.SETTINGSCODE.PRE_CG_TX_RT, fromModel.KEYREF.PreRetCGTxRt);
    postCGTaxRate = this.getFormValue(fromModel.SETTINGSCODE.POST_CG_TX_RT, fromModel.KEYREF.PostRetCGTxRt);
    //expSpendingPattern = this.getFormValue(fromModel.SETTINGSCODE.EXP_SPENDING_PATTERN, fromModel.KEYREF.ExpSpendingPattern);  
    expSpendingPattern = this.getFormValue(fromModel.SETTINGSCODE.EXP_SPENDING_PATTERN, null);  
    if(!expSpendingPattern){
      expSpendingPattern = "Y";    
    }

    if(this.getFormValue(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY, null)){
      this.planResultViewBy = <fromModel.PLANRESULTVIEWBY>this.getFormValue(fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY, null);
    } 
    
    this.form.setValue({
      infRate: infRate,
      discountRate: discountRate,
      preIncTaxRate: preIncTaxRate,      
      postIncTaxRate: postIncTaxRate,
      preCGTaxRate: preCGTaxRate,
      postCGTaxRate: postCGTaxRate,
      expSpendingPattern: expSpendingPattern      
    });

    this.form.valueChanges.subscribe(fm=>{      
      if(this.form.valid){
        this.isDataChanged = true;      
      } else {
        this.isDataChanged = false;      
      }
    });
  }

  onHideSettings(){
    this.hideSettings.emit();
  }

  showHideSettings(){
    this.isSettingsAvailable = false;
    this.showErrorMsg("Setting(s) are not available.");    
  }

  onChangePVFVSettings(selection: any){
    this.settingsToSave.push({code: fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY, value: selection});
    this.isDataChanged = true;
  }

  saveSettings(){
    //let settings: fromModel.CodeValue[] = [];
    if(this.form.valid && this.isDataChanged){
      //console.log(this.form.getRawValue());            
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.INF_RT, value: this.form.get('infRate').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.DISCOUNT_RT, value: this.form.get('discountRate').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.PRE_INC_TX_RT, value: this.form.get('preIncTaxRate').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.POST_INC_TX_RT, value: this.form.get('postIncTaxRate').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.PRE_CG_TX_RT, value: this.form.get('preCGTaxRate').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.POST_CG_TX_RT, value: this.form.get('postCGTaxRate').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.EXP_SPENDING_PATTERN, value: this.form.get('expSpendingPattern').value});
      this.settingsToSave.push({code: fromModel.SETTINGSCODE.PLAN_RESULT_VIEW_BY, value: this.planResultViewBy.toString()});
      this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATESETTINGS, "SettingsComponent-saveSettings", this.settingsToSave);      
      this.dataService.savePlan();      
      this.isDataChanged = false;      
    } 
    this.onHideSettings();

  }

  private showErrorMsg(msg){
    this.errorMsg = msg;   
  }
}
